/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Section } from './Section';
import {
    SectionFromJSON,
    SectionToJSON,
} from './Section';

/**
 *
 * @export
 * @interface Category
 */
export interface Category {
    /**
     *
     * @type {string}
     * @memberof Category
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof Category
     */
    id?: string | null;
    /**
     *
     * @type {string}
     * @memberof Category
     */
    slug?: string | null;
    /**
     *
     * @type {Array<Section>}
     * @memberof Category
     */
    sections?: Section[] | null;
}

/**
 * Check if a given object implements the Category interface.
 */
export function instanceOfCategory(value: object): value is Category {
    if (!('title' in value) || value['title'] === undefined) return false;
    return true;
}

export function CategoryFromJSON(json: any): Category {
    return CategoryFromJSONTyped(json, false);
}

export function CategoryFromJSONTyped(json: any, _: boolean): Category {
    if (json == null) {
        return json;
    }
    return {

        'title': json['title'],
        'id': json['id'] ?? undefined,
        'slug': json['slug'] ?? undefined,
        'sections': json['sections'] == null ? undefined : ((json['sections'] as any[]).map(SectionFromJSON)),
    };
}

export function CategoryToJSON(json: any): Category {
    return CategoryToJSONTyped(json, false);
}

export function CategoryToJSONTyped(value?: Category | null, _: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {

        'title': value['title'],
        'id': value['id'],
        'slug': value['slug'],
        'sections': value['sections'] == null ? undefined : ((value['sections'] as any[]).map(SectionToJSON)),
    };
}
